import { Media } from "./Media";
import { Card } from "./card";

export class Section {
 sectionName:any;
 sectionId:any;
 sectionDesc:string;
 splitesDesc=[];
 sectionTitleImage:any;
 sectionImage:any;
 sectionVideo:any;
 sectionFile:[];
 sectionStyle:any;
 sectionColour:any;
 cards: Card[] = [];
 sectionProImage:any;
 boardId:any
 sectionExpandFlag:boolean=false;
 media:Media[];
 fileCount:number;
 section_order:any
 created_date?: any;
 user_info: {
    name: '',
    username: '',
    drole: '',
    avatar: ''
  }
}
